<template>
  <div 
  id="footer" 
    :style="{ background: pageBackground }" 
    class=" relative  footer mt-20 bg-transparent md:mt-24 flex flex-col items-center  md:pb-24 fontFamilyText overflow-hidden"
  >
    <!-- Connect Section -->
    <section class="relative text-center text-white md:mt-32 max-md:mt-10">
      <h2 class="md:text-4xl montserrat text-3xl font-bold text-white ">Let's Connect!</h2>
      <p class="mt-10 text-3xl dancing-script font-medium max-md:mt-6 max-md:text-2xl">
        I am open to new opportunities and collaborations.
      </p>
      <p class="mt-4 text-3xl dancing-script font-medium max-md:mt-6 max-md:text-2xl">
        Let’s talk about the next big thing!
      </p>
      
      <ul class="flex flex-wrap justify-center gap-12 w-full max-w-md mx-auto mt-12">
        <li>
          <a href="mailto:psharma@tasksmail.com">
            <img loading="lazy" class="w-10 max-md:w-12 h-10" src="../assets/gmail.png" alt="Gmail">
          </a>
        </li>
        <li>
          <a href="http://linkedin.com/in/parinisthasharma">
            <img loading="lazy" class="w-10 max-md:w-12 h-10" src="../assets/linkedin.png" alt="LinkedIn">
          </a>
        </li>
        <li>
          <a href="mailto:psharm17@depaul.edu">
            <img loading="lazy" class="w-10 max-md:w-12 h-10" src="../assets/outlook.png" alt="Outlook">
          </a>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'MainComponent',
  props: {
    pageBackground: {
      type: String,
      default: 'transparent'
    }
  }
}
</script>

<style scoped>

</style>
